export const toTableRowItems = items =>
  items.map(item => ({
    id: item.id,
    shopCode: item.shopCode ?? '',
    supplierName: item.supplierName ?? '',
    supplierCode: item.supplierCode ?? '',
    supportName: item.supportName ?? '',
    supportId: item.supportId ?? '',
    supportCode: item.supportCode ?? '',
    parentSociety: item.parentSociety ?? '',
    stock: item.stock ?? '',
    lastUpdate: item.lastUpdate ?? ''
  }))
